import { Sidebar, SidebarProps, useLogout, useSidebarState } from 'react-admin';
import { alpha, Box, Button, Theme, Typography, useMediaQuery } from '@mui/material';
import { sidebar } from '../theme/theme';
import { LLButton } from '@/components-library';
import { KeyboardArrowLeft } from '@mui/icons-material';
import SwishLogo from '../shared/icons/SwishLogo';
import LogoutIcon from '@mui/icons-material/Logout';
import CommonIconInput from '@/src/components/inputs/CommonIconInput';
import { useEffect } from 'react';

const COCSideBar = (props: SidebarProps) => {
  const { children, ...rest } = props;
  const [sidebarOpen, setSidebarOpen] = useSidebarState();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const logout = useLogout();
  useEffect(() => {
    if (!isMobile) {
      setSidebarOpen(true);
    } else {
      setSidebarOpen(false);
    }
  }, [isMobile]);

  const sharedTransition =
    'opacity .195s cubic-bezier(0.4, 0, 0.6, 1), transform .195s cubic-bezier(0.4, 0, 0.6, 1), left .195s cubic-bezier(0.4, 0, 0.6, 1)';

  const sx = {
    title: {
      fontFamily: 'Mulish',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '19px',
      lineHeight: '24px',
      letterSpacing: '0.4px',
      color: (theme: any) => alpha(theme.palette.info[50], 0.7),
      marginLeft: 1.5,
    },
    sidebarSelectionLine: {
      opacity: '0',
      height: '100%',
      width: '20px',
      position: 'fixed',
      top: 0,
      left: sidebarOpen ? sidebar.width - 10 : sidebar.closedWidth - 10,
      transition: sharedTransition,
      cursor: 'pointer',
      '&:hover': {
        opacity: '1',
      },
      '&:before': {
        content: '""',
        display: 'block',
        width: '8px',
        height: '100%',
        position: 'absolute',
        top: 0,
        right: '8px',
        background:
          'linear-gradient(90deg, rgba(66,10,74,1) 0%, rgba(138,73,139,1) 50%, rgba(247,248,252,1) 100%)',
      },
    },
    sidebarSwitchContainer: {
      zIndex: 3000,
      position: 'fixed',
      top: '76px',
      left: sidebarOpen ? sidebar.width - 16 : sidebar.closedWidth - 16,
      borderRadius: '32px',
      width: '32px',
      height: '32px',
      backgroundColor: '#eff0fc',
      transition: sharedTransition,
      '&:hover + .sidebarSelectionLine': {
        opacity: '1',
      },
    },
    sidebarSwitch: {
      position: 'fixed',
      top: '76px',
      left: sidebarOpen ? sidebar.width - 16 : sidebar.closedWidth - 16,
      borderRadius: '32px',
      minWidth: '32px',
      width: '32px',
      height: '32px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'stretch',
      alignItems: 'stretch',
      p: 0,
      transition: sharedTransition,
    },
  };

  const logoScale = sidebarOpen ? 16 : 5;
  const logoPadding = sidebarOpen ? 4 : 0.5;
  const logoPl = sidebarOpen ? 4 : 0.5;

  return (
    <Box sx={{ position: 'relative' }}>
      <Sidebar
        {...rest}
        sx={{
          backgroundColor: '#0D2028',
          marginTop: '-48px',
          height: 'unset',
          '& .RaSidebar-fixed': {
            height: '100%',
            width: sidebarOpen ? sidebar.width : sidebar.closedWidth,
            transition: 'width .195s cubic-bezier(0.4, 0, 0.6, 1)',
            backgroundColor: '#0D2028',
            zIndex: 1100,
          },
          '&.RaSidebar-modal': {
            backgroundColor: 'transparent',
            '& .RaSidebar-paper': {
              height: '100%',
              backgroundColor: 'primary.main',
            },
            '& .MuiAccordion-root': {
              height: 'unset',
            },
          },
        }}
      >
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
          height="100%"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Box>
            <Box
              display="flex"
              alignItems="center"
              p={logoPadding}
              pl={logoPl}
              sx={{ transition: 'padding 195ms', justifyContent: 'center' }}
            >
              {sidebarOpen || isMobile ? (
                <Box>
                  <SwishLogo variant="white" text="bottom" scale={logoScale} />
                </Box>
              ) : null}
            </Box>
            <Box
              sx={{
                mt: sidebarOpen ? -4 : 0,
              }}
            >
              {props.children}
            </Box>
          </Box>
        </Box>
      </Sidebar>
    </Box>
  );
};

export default COCSideBar;
